<template>
    <v-content class="mortgage-list">
        <v-flex v-if="data.life && policyType.life">
            <v-flex class="mortgage-list__title mb-5 mt-3">
                <h3 class="approved-subtitle font-weight-bold">
                    Выберите страхование жизни
                </h3>
                <hr/>
            </v-flex>
            <div>
                <v-flex v-for="(item, key) in data.life" :key="'life-' + key">
                    <mortgage-result-item
                        :data="item"
                        type="life"
                        :parentKey="key"
                        :phone="phone"
                        :isResult="isResult"
                        :wait="wait"
                        :showCommission="showCommission"
                        @issue="issue"
                        @nextStep="nextStep"
                        :moreInfoLife="moreInfoLife"
                        :formIsChanged="formIsChanged"
                        :orderStatus="orderStatus"
                        :successProcessing="successProcessing"
                        :commissionsHidden="commissionsHidden"
                        @toggleComissions="toggleComissions"
                        @showConfirmModal="showConfirmModal"
                    ></mortgage-result-item>
                </v-flex>
            </div>
        </v-flex>
        <v-flex v-if="data.title && policyType.title">
            <v-flex class="mortgage-list__title mb-5 mt-3">
                <h3 class="approved-subtitle font-weight-bold">
                    Выберите страхование недвижимости и титула собственности
                </h3>
                <hr/>
            </v-flex>
            <transition-group name="list-complete" tag="p">
                <v-flex v-for="(item, key) in data.title" :key="'title-' + key" class="list-complete-item">
                    <mortgage-result-item
                        :data="item"
                        type="title"
                        :parentKey="key"
                        :phone="phone"
                        :isResult="isResult"
                        :wait="wait"
                        :showCommission="showCommission"
                        @nextStep="nextStep"
                        @issue="issue"
                        :moreInfoProperty="moreInfoProperty"
                        :formIsChanged="formIsChanged"
                        :orderStatus="orderStatus"
                        :successProcessing="successProcessing"
                        :commissionsHidden="commissionsHidden"
                        @toggleComissions="toggleComissions"
                        @showConfirmModal="showConfirmModal"
                    ></mortgage-result-item>
                </v-flex>
            </transition-group>
        </v-flex>
        <v-flex v-if="data.property && policyType.apartment && !policyType.title">
            <v-flex class="mortgage-list__title mb-5 mt-3">
                <h3 class="approved-subtitle font-weight-bold">
                    Выберите страхование недвижимости
                </h3>
                <hr/>
            </v-flex>
            <div>
                <v-flex v-for="(item, key) in data.property" :key="'property-' + key">
                    <mortgage-result-item
                        :data="item"
                        type="property"
                        :parentKey="key"
                        :phone="phone"
                        :isResult="isResult"
                        :wait="wait"
                        :showCommission="showCommission"
                        @nextStep="nextStep"
                        @issue="issue"
                        :moreInfoProperty="moreInfoProperty"
                        :formIsChanged="formIsChanged"
                        :orderStatus="orderStatus"
                        :successProcessing="successProcessing"
                        :commissionsHidden="commissionsHidden"
                        @toggleComissions="toggleComissions"
                        @showConfirmModal="showConfirmModal"
                    ></mortgage-result-item>
                </v-flex>
            </div>
        </v-flex>
        <v-flex v-if="data.union && policyType.life && policyType.apartment && !policyType.title">
            <hr/>
            <div>
                <v-flex v-for="(item, key) in data.union" :key="'union-' + key"
                        :ref="key"
                >
                    <mortgage-result-item
                        :data="item"
                        type="union"
                        :parentKey="key"
                        :duration="duration"
                        :phone="phone"
                        :isResult="isResult"
                        :wait="wait"
                        :showCommission="showCommission"
                        @nextStep="nextStep"
                        @issue="issue"
                        :moreInfoProperty="moreInfoProperty"
                        :moreInfoLife="moreInfoLife"
                        :formIsChanged="formIsChanged"
                        :orderStatus="orderStatus"
                        :successProcessing="successProcessing"
                        :commissionsHidden="commissionsHidden"
                        @toggleComissions="toggleComissions"
                        @showConfirmModal="showConfirmModal"
                    ></mortgage-result-item>
                </v-flex>
            </div>
        </v-flex>
        <v-flex v-if="data.titleUnion && policyType.life && policyType.apartment && policyType.title">
            <hr/>
            <transition-group name="list-complete" tag="p">
                <v-flex v-for="(item, key) in data.titleUnion" :key="'union-' + key"
                        class="list-complete-item"
                        :ref="key"
                >
                    <mortgage-result-item
                        :data="item"
                        type="titleUnion"
                        :parentKey="key"
                        :duration="duration"
                        :phone="phone"
                        :isResult="isResult"
                        :wait="wait"
                        :showCommission="showCommission"
                        @nextStep="nextStep"
                        @issue="issue"
                        :moreInfoProperty="moreInfoProperty"
                        :moreInfoLife="moreInfoLife"
                        :formIsChanged="formIsChanged"
                        :orderStatus="orderStatus"
                        :successProcessing="successProcessing"
                        @showConfirmModal="showConfirmModal"
                    ></mortgage-result-item>
                </v-flex>
            </transition-group>
        </v-flex>
    </v-content>
</template>

<script>

import MortgageResultItem from "./MortgageResultItem";

export default {
    name: "MortgageResultList",
    props: [
        'data',
        'policyType',
        'duration',
        'phone',
        'isResult',
        'wait',
        'showCommission',
        'formIsChanged',
        'orderStatus',
        'successProcessing',
        'precalcBank',
        'step'
    ],
    components: {
        'mortgage-result-item': MortgageResultItem
    },
    data: () => ({
       moreInfoProperty: [
           {
               name: 'Пари',
               number: '№ К-133/2022-С',
               age: 'от 18 до 65 лет',
               total: 'от 100 000 руб. до 25 000 000 руб.',
               location: '',
               build: ''
           },
           {
               name: 'Абсолют',
               number: '№ АГД-001-002571/22',
               age: '',
               total: '',
               location: 'Чечня, Ингушетия, Дагестан, Карачаево-Черкессия, Кабардино-Балкария, Сев. Осетия, Крым',
               build: 'после 1965 года, имеет более 3 наземных этажей'
           },
           {
               name: 'Зетта',
               number: '№ АГД-610-422528/21',
               age: '',
               total: '',
               location: '',
               build: ''},
           {
               name: 'Альфа',
               number: '№ Р-01122018-01',
               age: 'от 18 до 67 лет',
               total: 'от 100 000 руб. до 5 000 000 руб.',
               location: '',
               build: ''},
           {
               name: 'ВСК',
               number: '№ 17179600001',
               age: '',
               total: 'до 25 000 000 руб.',
               location: 'Россия, кроме Крыма и Севастополя',
               build: 'от 1955 года'},
           {
               name: 'Ренессанс',
               number: '№ AG-0104/2020',
               age: '',
               total: 'до 25 000 000 руб.',
               location: '',
               build: ''},
           {
               name: 'Росгосстрах',
               number: '№ 63',
               age: '',
               total: 'до 25 000 000 руб.',
               location: 'Россия, за исключением Ингушетии, Чечни, Дагестана, Крыма, Севастополя',
               build: '',
               materials: 'Отсутствуют деревянные стены и/или перекрытия, газоболонное оборудование, перепланировки'
           },
           {
               name: 'Югория',
               number: '№ АД-04 №017372-36/20',
               age: '',
               total: '',
               location: '',
               build: 'от 1945 года'},
           {
               name: 'Совкомбанк',
               number: '№ 13845-22',
               age: 'от 18 до 60 лет',
               total: 'до 7 000 000 руб.',
               location: '',
               build: ''},
           {
               name: 'Энерго Гарант',
               number: '№ 13845-22',
               age: 'от 18 до 60 лет',
               total: 'до 18 000 000 руб.',
               location: '',
               materials: 'Отсутствуют деревянные стены и/или перекрытия',
               build: ''},
           {
               name: 'Ингосстрах',
               number: '№ 0359231-8/23',
               age: 'от 18 до 60 лет',
               wear: 'до 69% включительно Объекты, находящиеся в аварийном состоянии и/или назначенные под снос',
               total: 'до 6 500 000 руб.',
               location: '',
               materials: 'Отсутствуют деревянные стены и/или перекрытия',
               build: ''},
       ],
       moreInfoLife: [
           {
               name: 'Пари',
               number: '№ К-133/2022-С',
               age: 'от 18 до 45 лет',
               total: 'от 100 000 руб. до 25 000 000 руб.',
               location: '',
               weight: 'от 17 до 33'
           },
           {
               name: 'Абсолют',
               number: '№ АГД-001-002571/22',
               age: 'от 18 до 45 лет',
               total: 'до 5 000 000 руб.',
               location: 'Чечня, Ингушетия, Дагестан, Карачаево-Черкессия, Кабардино-Балкария, Сев. Осетия, Крым',
               weight: ''
           },
           {
               name: 'Зетта',
               number: '№ АГД-610-422528/21',
               age: '',
               total: '',
               location: '',
               weight: ''
           },
           {
               name: 'Альфа',
               number: '№ Р-01122018-01',
               age: 'от 18 до 67 лет',
               total: 'от 100 000 руб. до 3 000 000 руб.',
               location: '',
               weight: ''
           },
           {
               name: 'ВСК',
               number: '№ 17179600001',
               age: 'от 18 до 60 лет',
               total: 'до 45 лет - 25 000 000 руб.,\nдо 55 лет - 7 500 000 руб.,\nдо 60 лет - 1 000 000 руб.',
               location: '',
               weight: ''
           },
           {
               name: 'Ренессанс',
               number: '№ AG-0104/2020',
               age: 'от 18 до 60 лет',
               total: 'до 25 000 000 руб.',
               location: '',
               weight: ''
           },
           {
               name: 'Росгосстрах',
               number: '№ 63',
               age: 'от 21 до 50 лет',
               total: 'до 45 лет - 5 000 000 руб.,\nдо 50 лет - 1 000 000 руб.',
               location: '',
               weight: ''
           },
           {
               name: 'Югория',
               number: '№ АД-04 №017372-36/20',
               age: '',
               total: 'до 44 лет - 8 000 000 руб.,\nдо 54 лет - 5 000 000 руб.,\nот 55 лет - 1 500 000 руб.',
               location: '',
               weight: ''
           },
           {
               name: 'Совкомбанк',
               number: '№ 13845-22',
               age: 'от 18 до 60 лет',
               total: 'до 7 000 000 руб.',
               location: '',
               weight: ''
           },
           {
               name: 'Энерго Гарант',
               number: '№ 13845-22',
               age: 'от 18 до 50 лет',
               total: 'до 40 лет - до 18 000 000 руб.,\nот 41 лет - до 12 000 000 руб.,\nот 46 до 50 лет - до 8 000 000 руб.',
               location: '',
               weight: ''
           },
           {
               name: 'Ингосстрах',
               number: '№ 0359231-8/23',
               age: 'от 18 до 60 лет',
               total: 'до 6 500 000 руб.',
               location: '',
               weight: ''
           },
       ],
        moreInfoTitle: [
            {
                name: 'Альфа',
                age: 'от 18 до 67 лет',
                total: 'от 100 000 руб. до 3 000 000 руб.',
            }
        ],
        commissionsHidden: false,
    }),
    created() {
        if (this.data.property) {
            this.data.property.forEach((item) => {
                // конкретно для ВТБ и ПАРИ
                if (
                    item.apartment === 'pari_mortgage'
                    && this.precalcBank === 'vtb'
                    && (this.step === 1 || this.step === 2)
                ) {
                    item.premium = 0;
                }

                item.panel = []
                item.showMore = false
            })
        }
        if (this.data.life) {
            this.data.life.forEach((item) => {
                // конкретно для ВТБ и ПАРИ
                if (
                    item.apartment === 'pari_mortgage'
                    && this.precalcBank === 'vtb'
                    && (this.step === 1 || this.step === 2)
                ) {
                    item.premium = 0;
                }

                item.panel = []
                item.showMore = false
            })
        }
        if (this.data.union) {
            this.data.union.forEach((item) => {
                // конкретно для ВТБ и ПАРИ
                if (
                    item.apartment === 'pari_mortgage'
                    && this.precalcBank === 'vtb'
                    && (this.step === 1 || this.step === 2)
                ) {
                    item.premium = 0;
                }

                item.panel = []
                item.showMore = false
            })
        }
    },
    methods: {
        nextStep() {
            this.$emit('nextStep')
        },
        issue(data) {
            this.$nextTick(() => {
                this.$emit('issue', data)
            })
        },
        toggleComissions() {
            this.commissionsHidden = !this.commissionsHidden;
        },
        showConfirmModal(confirmModalItems) {
            this.$emit('showConfirmModal', confirmModalItems)
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/components/mortgage/MortgageResultList.vue